/*
 *
 * ForeignCardDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 25-Feb-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import Dialog from '@mui/material/Dialog'
import PortalTabs from '@nexidigital/portaltabs'
import FlowTemplate from 'Components/Template/FlowTemplate'
import ForeignCardFirstPeriodDetail from './ForeignCardFirstPeriodDetail'
import ForeignCardSecondPeriodDetail from './ForeignCardSecondPeriodDetail'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import { Dismiss } from '@nexidigital/iconlibrary'
import formattedMessage from './languageModule'
import './ForeignCardDetail.scss'

const ForeignCardDetail = ({ actions, open, tabSelected, groupByCountry, referredPeriod }) => {
  const { isSmallScreen } = useMobileDetect()

  // Nullsafe: verifica che groupByCountry e i suoi periodi esistano
  const periodOne = groupByCountry?.periodOne || {}
  const periodOneCountries = periodOne.countries || []
  const periodTwo = groupByCountry?.periodTwo || {}
  const periodTwoCountries = periodTwo.countries || []

  const tabData = [
    {
      label: formattedMessage.tabData1,
      content: <ForeignCardFirstPeriodDetail referredPeriod={referredPeriod} countries={periodOneCountries} totals={periodOne} />
    },
    {
      label: formattedMessage.tabData2,
      content: <ForeignCardSecondPeriodDetail referredPeriod={referredPeriod} countries={periodTwoCountries} totals={periodTwo} />
    }
  ]

  return (
    <Toggle>
      <Dialog fullScreen open={open} className='ForeignCardDetailDialog'>
        <FlowTemplate
          flowBackground
          titleNavigation={formattedMessage.titleNavigation}
          iconCloseRight={<Dismiss size={isSmallScreen ? '24' : '20'} type='line' />}
          labelButtonRightNav={formattedMessage.close}
          onClickClose={() => actions.doClosePopup()}
          emptyPage
        >
          <sector className='foreignCardDetail'>
            {tabSelected === 'TWO_PERIODS'
              ? (
                <PortalTabs merchant tabData={tabData} />
                )
              : (
                <ForeignCardFirstPeriodDetail referredPeriod={referredPeriod} countries={periodOneCountries} totals={periodOne} />
                )}
          </sector>
        </FlowTemplate>
      </Dialog>
    </Toggle>
  )
}

ForeignCardDetail.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  actions: PropTypes.object,
  period: PropTypes.string,
  /** This props is used to get the current tab of results */
  tabSelected: PropTypes.string,
  /** This props is used to open the dialog */
  open: PropTypes.bool,
  groupByCountry: PropTypes.object,
  referredPeriod: PropTypes.arrayOf(PropTypes.string)
}

ForeignCardDetail.defaultProps = {
  // Add here some default propTypes values
  actions: {},
  period: '',
  tabSelected: 'ONE_PERIOD',
  open: false,
  groupByCountry: {},
  referredPeriod: []
}

export default ForeignCardDetail
